import { KeyboardEvent } from 'react'

export const onClickARIA = (callback: (e?: KeyboardEvent) => void) => {
  return (e: KeyboardEvent) => {
    if (e.code === 'Space' || e.code === 'Enter') {
      callback(e)
    }
  }
}
